import camelCase from '../../../../utils/camelCase';
import { DeliveryOption } from '../../../../utils/checkoutState';

const getCollectionPointI18nKey = ({
  collectionPointType,
  carrierGroupKey
}: Pick<DeliveryOption, 'collectionPointType' | 'carrierGroupKey'>) =>
  camelCase(
    collectionPointType === 'post_office' ? `${carrierGroupKey}_postoffice`
    : collectionPointType === 'parcel_shop' ? `${carrierGroupKey}_parcelshop`
    : collectionPointType === 'packstation' ? `${carrierGroupKey}_packstation`
    : collectionPointType!
        .replace('_new', '')
        .replace('all', 'parcelshop')
        .replace('balikovna_cz_packstation', 'balikovnaPackstation')
        .replace('balikovna_cz_parcelshop', 'balikovnaParcelshop')
        .replace('balikovna_cz_post_office', 'balikovnaPostoffice')
        .replace('bpackparcelpackstation', 'packstation')
        .replace('bpostbe', 'bpost')
        .replace('colissimo_sfr_packstation', 'colissimoPackstation')
        .replace('colissimo_sfr_parcelshop', 'colissimoParcelshop')
        .replace('FAN_RO', 'fanro')
        .replace('fedex_ses_packstation', 'fedexPackstation')
        .replace('fedex_ses_parcelshop', 'fedexParcelshop')
        .replace('gls_dk', 'gls')
        .replace('glshu', 'gls')
        .replace('inpost_spl_packstation', 'inpostPackstation')
        .replace('inpost_spl_parcelshop', 'inpostParcelshop')
        .replace('locker', 'packstation')
        .replace('lpc_conveniencestores', 'colissimo_parcelshop')
        .replace('mypost24', 'packstation')
        .replace('parcel_shop', 'parcelshop')
        .replace('parcelbox', 'packstation')
        .replace('parcelpoint', 'parcelshop')
        .replace('pickpost', 'parcelshop')
        .replace('post_office', 'postoffice')
        .replace('postat_hps', 'hermes_packstation')
        .replace('postbank', 'postoffice')
        .replace('postnord_se_packstation', 'postnordPackstation')
        .replace('postnord_se_parcelshop', 'postnordParcelshop')
        .replace('postnord_se_post_office', 'postnordPostoffice')
        .replace('postparcelshop', 'parcelshop')
        .replace('reba', carrierGroupKey)
        .replace('sda_sit_packstation', 'sdaPackstation')
        .replace('sda_sit_parcelshop', 'sdaParcelshop')
        .replace('servicepoint', 'parcelshop')
        .replace('SPEEDY_FREE_SHIPPING', 'speedy')
        .replace('SPEEDY', 'speedy')
        .replace('UB_', '')
        .replace('ups_ses_packstation', 'upsPackstation')
        .replace('ups_ses_parcelshop', 'upsParcelshop')
        .replace('ups_sit_packstation', 'upsPackstation')
        .replace('ups_sit_parcelshop', 'upsParcelshop')
        .replace('ups_spt_packstation', 'upsPackstation')
        .replace('ups_spt_parcelshop', 'upsParcelshop')
        .replace('ZASIL_CZ', 'zasilcz')
        .replace('ZASIL_SK', 'zasilsk')
        .replace('dhl_pl', 'dhl')
        .replace('inpost_pl', 'inpost')
  );

export default getCollectionPointI18nKey;
